
import Icon from '../../../components/AppIcon';


const ServicesOverview = () => {
  const services = [
  {
    id: 1,
    title: "Emergency Plumbing",
    description: "Rapid response to leaks, burst pipes, and plumbing emergencies with 24/7 availability and guaranteed response times under 60 minutes",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ea2aa366-1767678265006.png",
    imageAlt: "Professional plumber in blue uniform working on copper pipes under kitchen sink with tools and equipment visible",
    icon: "Droplet",
    link: "/plumbing-services",
    features: ["Leak Detection", "Pipe Repairs", "Drain Clearing", "Water Heater Service"]
  },
  {
    id: 2,
    title: "Electrical Services",
    description: "Expert fault finding, diagnostics, and electrical repairs with comprehensive safety testing and compliance certification",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b19239b5-1764686240320.png",
    imageAlt: "Certified electrician in safety gear testing electrical panel with multimeter in modern commercial building",
    icon: "Zap",
    link: "/electrical-services",
    features: ["Fault Finding", "Safety Testing", "Installations", "Emergency Repairs"]
  },
  {
    id: 3,
    title: "Commercial Projects",
    description: "Complex installations and maintenance for restaurants, retail chains, and commercial facilities with proven track record",
    image: "https://images.unsplash.com/photo-1664079555500-6af5e94374bb",
    imageAlt: "Large scale commercial construction site with modern office building framework and industrial equipment in background",
    icon: "Building2",
    link: "/commercial-experience",
    features: ["System Design", "Installation", "Maintenance", "Compliance"]
  },
  {
    id: 4,
    title: "Drive Thru Clean Up",
    description: "Professional high-pressure cleaning of drive-thru lanes, canopies, and surfaces — keeping your outlet hygienic and customer-ready",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c2d0195b-1772292082290.png",
    imageAlt: "High-pressure water jet cleaning a commercial concrete surface with foam and water spray visible",
    icon: "Car",
    link: "/drive-thru-cleanup",
    features: ["Pressure Washing", "Grease Removal", "Canopy Cleaning", "Sanitisation"]
  },
  {
    id: 5,
    title: "Equipment Repair",
    description: "Fast on-site diagnosis and repair of commercial equipment to minimise downtime and keep your operations running smoothly",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_143fab088-1766756813161.png",
    imageAlt: "Technician in work uniform repairing industrial commercial kitchen equipment with tools on workbench",
    icon: "Wrench",
    link: "/equipment-repair",
    features: ["Fault Diagnosis", "Component Replacement", "Calibration", "Service Reports"]
  },
  {
    id: 6,
    title: "Fat Traps",
    description: "Thorough grease trap pump-out and cleaning for restaurants and commercial kitchens — preventing blockages and ensuring compliance",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_130de0b13-1766887883996.png",
    imageAlt: "Commercial kitchen drainage system with grease trap maintenance being performed by a technician",
    icon: "Droplets",
    link: "/fat-traps",
    features: ["Pump-Out", "Deep Cleaning", "Odour Treatment", "Compliance Cert"]
  },
  {
    id: 7,
    title: "Painting",
    description: "High-quality interior and exterior commercial painting with durable finishes suited for high-traffic environments",
    image: "https://images.unsplash.com/photo-1725371641476-0991d38a06fe",
    imageAlt: "Professional painter applying white paint to commercial building exterior wall with roller and brush",
    icon: "Paintbrush",
    link: "/painting-services",
    features: ["Surface Prep", "Interior & Exterior", "Epoxy Floors", "Brand Colours"]
  },
  {
    id: 8,
    title: "Industrial Refrigerators",
    description: "Installation, servicing, and emergency repair of commercial cold rooms and refrigeration units to protect your stock",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17a44277f-1772292082238.png",
    imageAlt: "Large industrial walk-in cold room with stainless steel shelving and refrigeration units in commercial kitchen",
    icon: "Thermometer",
    link: "/industrial-refrigerators",
    features: ["Installation", "Gas Top-Ups", "Compressor Repair", "Temperature Testing"]
  },
  {
    id: 9,
    title: "Road Markings & Signage",
    description: "Professional car park bay marking, road line painting, and custom signage board installation for commercial properties",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dda8707b-1772292079968.png",
    imageAlt: "Freshly painted white road markings and parking bay lines on commercial car park tarmac surface",
    icon: "MapPin",
    link: "/road-markings",
    features: ["Bay Marking", "Directional Arrows", "Safety Zones", "Custom Signage"]
  }];


  return (
    <section className="py-12 md:py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-5xl font-bold text-foreground mb-4">
            Comprehensive Service Solutions
          </h2>
          
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto">
            From emergency repairs to complex commercial installations, we deliver expert solutions backed by 30+ years of proven experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services?.map((service) =>
          <div key={service?.id} className="group bg-card rounded-xl overflow-hidden shadow-elevated hover:shadow-lg transition-all duration-300 border border-border">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                src={service?.image}
                alt={service?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 flex items-center gap-3">
                  <div className="bg-accent p-3 rounded-lg">
                    <Icon name={service?.icon} size={24} color="white" />
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold text-white">{service?.title}</h3>
                </div>
              </div>

              <div className="p-6 md:p-8">
                <p className="text-sm md:text-base text-muted-foreground mb-6">
                  {service?.description}
                </p>

                <div className="space-y-3 mb-6">
                  {service?.features?.map((feature, index) =>
                <div key={index} className="flex items-center gap-2">
                      <Icon name="Check" size={18} color="var(--color-success)" />
                      <span className="text-sm md:text-base text-foreground">{feature}</span>
                    </div>
                )}
                </div>

                <a href={service?.link} className="block">
                  <button className="w-full flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-3 rounded-lg font-semibold transition-all duration-300">
                    <span>Learn More</span>
                    <Icon name="ArrowRight" size={18} />
                  </button>
                </a>
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 md:mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-accent/10 backdrop-blur-sm px-6 md:px-8 py-4 md:py-6 rounded-xl border border-accent/30">
            <Icon name="Phone" size={32} color="var(--color-accent)" />
            <div className="text-center sm:text-left">
              <p className="text-sm md:text-base text-muted-foreground mb-1">Need immediate assistance?</p>
              <a href="tel:0827935785" className="text-xl md:text-2xl font-bold text-accent hover:text-accent/80 transition-colors">
                082 793 5785
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default ServicesOverview;